import { browserVersion, isIE } from 'react-device-detect'

// <=IE9 (bug in polyfill.io, it doesnt include matchMedia
// https://github.com/Financial-Times/polyfill-library/issues/71
/// PR was made with fix, check if deployed to their production to remove this:
if (isIE && browserVersion <= 9) {
    require('matchmedia-polyfill')
    require('matchmedia-polyfill/matchMedia.addListener')
}
